__turbopack_context__.v({
  "empty": "WShopBestsellerProducts-module__Ty_qOq__empty",
  "header": "WShopBestsellerProducts-module__Ty_qOq__header",
  "heading": "WShopBestsellerProducts-module__Ty_qOq__heading",
  "productList": "WShopBestsellerProducts-module__Ty_qOq__productList",
  "root": "WShopBestsellerProducts-module__Ty_qOq__root",
  "showAllBtn": "WShopBestsellerProducts-module__Ty_qOq__showAllBtn",
});
